import type { RegisteredComponent } from "@builder.io/sdk-react";

import { useAuth } from "~/hec/context/auth-context";

interface GuestContentProps {
  children?: React.ReactNode;
  attributes?: Record<string, unknown>;
}

/**
 * GuestContent — conditional wrapper that only renders children when the user
 * is NOT logged in. Used inside Builder content (e.g. Account Dropdown) to
 * show guest-specific UI such as login/register links.
 */
const GuestContent = ({ children, attributes }: GuestContentProps) => {
  const { isLoggedIn } = useAuth();
  if (isLoggedIn) return null;
  return <div {...attributes}>{children}</div>;
};

export const GuestContentDefinition = {
  component: GuestContent,
  name: "GuestContent",
  noWrap: true,
  canHaveChildren: true,
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/user.svg",
  inputs: [],
} satisfies RegisteredComponent;

export default GuestContent;
